"use strict";
// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
var DefaultDeviceController_1 = require("../devicecontroller/DefaultDeviceController");
var ContentShareMediaStreamBroker = /** @class */ (function () {
    function ContentShareMediaStreamBroker(logger) {
        this.logger = logger;
    }
    Object.defineProperty(ContentShareMediaStreamBroker.prototype, "mediaStream", {
        get: function () {
            return this._mediaStream;
        },
        set: function (mediaStream) {
            this._mediaStream = mediaStream;
        },
        enumerable: true,
        configurable: true
    });
    ContentShareMediaStreamBroker.prototype.acquireAudioInputStream = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._mediaStream.getAudioTracks().length === 0) {
                    return [2 /*return*/, DefaultDeviceController_1.default.synthesizeAudioDevice(0)];
                }
                return [2 /*return*/, this._mediaStream];
            });
        });
    };
    ContentShareMediaStreamBroker.prototype.acquireVideoInputStream = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._mediaStream];
            });
        });
    };
    ContentShareMediaStreamBroker.prototype.releaseMediaStream = function (_mediaStreamToRelease) {
        this.logger.warn('release media stream called');
        return;
    };
    ContentShareMediaStreamBroker.prototype.acquireDisplayInputStream = function (streamConstraints) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (streamConstraints &&
                    streamConstraints.video &&
                    // @ts-ignore
                    streamConstraints.video.mandatory &&
                    // @ts-ignore
                    streamConstraints.video.mandatory.chromeMediaSource &&
                    // @ts-ignore
                    streamConstraints.video.mandatory.chromeMediaSourceId) {
                    return [2 /*return*/, navigator.mediaDevices.getUserMedia(streamConstraints)];
                }
                // @ts-ignore https://github.com/microsoft/TypeScript/issues/31821
                return [2 /*return*/, navigator.mediaDevices.getDisplayMedia(streamConstraints)];
            });
        });
    };
    ContentShareMediaStreamBroker.prototype.bindToAudioVideoController = function (_audioVideoController) {
        throw new Error('unsupported');
    };
    ContentShareMediaStreamBroker.prototype.acquireScreenCaptureDisplayInputStream = function (sourceId, frameRate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.acquireDisplayInputStream(this.screenCaptureDisplayMediaConstraints(sourceId, frameRate))];
            });
        });
    };
    ContentShareMediaStreamBroker.prototype.screenCaptureDisplayMediaConstraints = function (sourceId, frameRate) {
        return {
            audio: !sourceId && new DefaultBrowserBehavior_1.default().getDisplayMediaAudioCaptureSupport()
                ? true
                : false,
            video: __assign(__assign({}, (!sourceId && {
                frameRate: {
                    max: frameRate ? frameRate : ContentShareMediaStreamBroker.defaultFrameRate,
                },
            })), (sourceId && {
                mandatory: {
                    chromeMediaSource: 'desktop',
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRate ? frameRate : ContentShareMediaStreamBroker.defaultFrameRate,
                },
            })),
        };
    };
    ContentShareMediaStreamBroker.prototype.toggleMediaStream = function (enable) {
        var changed = false;
        if (this.mediaStream) {
            for (var i = 0; i < this.mediaStream.getTracks().length; i++) {
                if (this.mediaStream.getTracks()[i].enabled !== enable) {
                    this.mediaStream.getTracks()[i].enabled = enable;
                    changed = true;
                }
            }
        }
        return changed;
    };
    ContentShareMediaStreamBroker.prototype.cleanup = function () {
        if (this.mediaStream) {
            for (var i = 0; i < this.mediaStream.getTracks().length; i++) {
                this.mediaStream.getTracks()[i].stop();
            }
        }
        this.mediaStream = null;
    };
    ContentShareMediaStreamBroker.defaultFrameRate = 15;
    return ContentShareMediaStreamBroker;
}());
exports.default = ContentShareMediaStreamBroker;
//# sourceMappingURL=ContentShareMediaStreamBroker.js.map